import React, { Component } from 'react';
import {Link} from 'react-router-dom';




class UnitListItem extends Component {

   constructor(props) {
    super(props);

    this.removeUnit = this.removeUnit.bind(this);

     this.state={
        
     }
  }

  removeUnit()
  {
      console.log('clicked remove');
    this.props.removeUnit(this.props.unit)
  }

  
  render() {
    const _this=this;

    return (
        <tr>
                  <td>
                      {this.props.unit.Code}
                  </td>
                  <td>
                      {this.props.unit.Names}
                  </td>
                  <td>
                      <img src="/img/close.png" onClick={_this.removeUnit.bind(_this)} width="30px" height="30px"/>
                  </td>

        </tr>



    );
  }




}

export default UnitListItem;